import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import MainCardContainer from '../../components/MainCardContainer/';
import { STAFFID, CATEGORY_ID } from './../../data/constants/';
import Loader from './../../components/Loader';
import BidTable from './../BidSession/components/BidTable';
import CardRow from './../../components/CardRow';
import OtherOptions from './../BidSession/components/OtherOptions';
import { fetchPastBidSession } from './actions';
import { useLanguage } from '../../context/LanguageContext';

const PastSession = (props) => {
  const { labels } = useLanguage();
  const BID_TABLE = labels.BID_TABLE || {};
  const PAST_SESSION = labels.PAST_SESSION || {};
  const OTHER_OPTIONS = labels.otherOptions || {};
  const [sessionName, setSessionName] = useState('');
  const [bidPreferences, setBidPreferences] = useState({ entries: [] });
  const [otherOptions, setOtherOptions] = useState({ entries: [] });
  const [isFetching, setIsFetching] = useState(true);
  const [bidmode, setBidmode] = useState('');
  const [displayScope, setDisplayScope] = useState(false)

  useEffect(() => {
    const staffId = sessionStorage.getItem(STAFFID);
    const categoryId = sessionStorage.getItem(CATEGORY_ID);
    const { sessionId } = props.match.params;
    const bidSessionId = parseInt(sessionId, 10);

    setIsFetching(true);

    fetchPastBidSession(staffId, bidSessionId, categoryId)
    .then(
      axios.spread((openBidsResponse, bidPreferencesResponse, otherOptionsResponse, resBidMode, resBidScopeRequest, resBidScopePreferenceOptions) => {
      const bidPrefs = bidPreferencesResponse.data;
      const otherOps = otherOptionsResponse.data;
      const openBids = openBidsResponse.data;
      const currentBid = openBids.entries
        .filter(bid => bid.bidSessionId === Number(bidSessionId))[0];
      const bidMode = resBidMode.data;
      const bidScopeRequest = resBidScopeRequest.data;
      const bidScopePreferenceOptions = resBidScopePreferenceOptions.data;

      setBidPreferences(bidPrefs);
      setSessionName(currentBid.name);
      setOtherOptions(otherOps);
      setBidmode(bidMode);

      if(bidScopeRequest) {
        if(bidScopePreferenceOptions && bidScopePreferenceOptions.entries.length >= 1) setDisplayScope(true)
      }

      setIsFetching(false);
    }))
    .catch(error => console.log(error));
  }, [props.match.params]);

  return (
    <div>
      { isFetching ? <Loader /> :
      <MainCardContainer
        headTitle={`${sessionName} Session`}
        headSubtitle={PAST_SESSION.SUBTITLE}
        readOnly
        content={[
          <CardRow
            key={0}
            cardNumber={1}
            cards={[
              <BidTable
                readOnly
                key={0}
                bidSession={{ bidPreferences, bidMode: bidmode, filteredBidPreferences: JSON.parse(JSON.stringify(bidPreferences)), displayScope }}
                title={BID_TABLE.PAST_SESSION.CARD_TITLE}
                subtitle={BID_TABLE.PAST_SESSION.CARD_SUBTITLE}
                listTitle={BID_TABLE.PAST_SESSION.LIST_TITLE}
              />
            ]}
          />,
          <CardRow
            key={1}
            cardNumber={1}
            cards={[
              <OtherOptions
                readOnly
                key={0}
                otherOptions={otherOptions}
                title={OTHER_OPTIONS.PAST_SESSION.TITLE}
                subtitle={OTHER_OPTIONS.PAST_SESSION.SUBTITLE}
              />]}
          />,
        ]}
      />
      }
    </div>
  );
};

PastSession.propTypes = {
  params: PropTypes.object.isRequired,
};

export default PastSession;
